import type { IconSvgObject } from './types';

const CornerLeftDownIcon: IconSvgObject = [
  ["path", { d: "M9 19L9 12C9 8.22876 9 6.34314 10.1716 5.17157C11.3431 4 13.2288 4 17 4L20 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 15C4 15 7.68244 20 9.00004 20C10.3176 20 14 15 14 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerLeftDownIcon;
